import React from "react";
import { useCargasForm } from "../hooks/useCargasForm";
import LoadMask from "Utils/LoadMask/LoadMask";
import { ListadoCargas } from "./ListadoCargas";
import { ResumenTotal } from "./ResumenTotal";

export const CargasForm = ({ idTancada, regresar }) => {
    const cargasFormHook = useCargasForm(idTancada, regresar);

    const {
        cargasTancada,

        cargando,
    } = cargasFormHook;

    return (
        <LoadMask loading={cargando} blur>
            <ListadoCargas
                idTancada={idTancada}
                cargasFormHook={cargasFormHook}
            />
            <ResumenTotal cargasTancada={cargasTancada} />
            <div className="d-flex justify-content-center mt-3 gap-1rem">
                <button className="btn btn-outline-dark" onClick={regresar}>
                    Regresar
                </button>
            </div>
        </LoadMask>
    );
};
